
import request from "../utils/request";

export function cmsAddgoods(data) {
    return request({
        url: "/shop/cmsAddgoods",
        data: data,
    });
}

export function updateShopStatus(data) {
    return request({
        url: "/shop/updateShopStatus",
        data: data,
    });
}

export function cmsSelShop(data) {
    return request({
        url: "/shop/cmsSelShop",
        data: data,
    });
}

export function cmsUpdateGoodsNum(data) {
    return request({
        url: "/shop/cmsUpdateGoodsNum",
        data: data,
    });
}

export function cmsExhangeList(data) {
    return request({
        url: "/shop/cmsExhangeList",
        data: data,
    });
}


